import { render, staticRenderFns } from "./PppoeplusPortConfig.vue?vue&type=template&id=6161871a&"
import script from "./PppoeplusPortConfig.vue?vue&type=script&lang=js&"
export * from "./PppoeplusPortConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports